import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import { Form, Table } from "react-bootstrap";
import { fetchAllDataAPI, filterByParams } from "../../utils/api";
import Skeleton from "react-loading-skeleton";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import ReportNavBar from "../../components/ReportNavBar";
import withAuth from "../../utils/withAuth";
import { CiExport } from "react-icons/ci";
import CsvDownloader from "react-csv-downloader";

const SameProductReport = () => {
    const [headers, setHeaders] = useState([]);
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });

    useEffect(() => {
        getAgentWisePivoteReport();
    }, []);

    const getAgentWisePivoteReport = async () => {
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI(
                "super-admin-get-agent-wise-product-pivot-report-current-months"
            );
            if (res.data.status === 1) {
                setHeaders(res.data.report.headers);
                setRows(res.data.report.rows);
                setFilteredRows(res.data.report.rows);
            }
        } catch (error) {
            console.error("Error fetching report:", error);
        }
        setIsLoading(false);
    };
    const handleFilterByDate = async (event, picker) => {
        setIsLoading(true);
        const selectedRange = {
            startDate: picker.startDate.format("YYYY-MM-DD"),
            endDate: picker.endDate.format("YYYY-MM-DD")
        };
        setDateRange(selectedRange);
        try {
            const res = await filterByParams("super-admin-get-agent-performance-by-daterange", selectedRange);
            if (res.data.status === 1) {
                setHeaders(res.data.report.headers);
                setRows(res.data.report.rows);
                setFilteredRows(res.data.report.rows);
            }
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };
    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = rows.filter((item) =>
            item.agent_name?.toLowerCase().includes(value)
        );
        setFilteredRows(filtered);
    };

    const handleReset = () => {
        setSearchTerm("");
        setFilteredRows(rows);
    };

    const columns = headers.map((h) => ({
        id: h,
        displayName: h,
    }));

    const column = [
        { id: 's_no', displayName: 'Serial No' },
        { id: 'agent_name', displayName: 'Agent Name' },
        { id: 'agent_emp_id', displayName: 'Agent Emp ID' },
        ...headers
            .filter((h) => !['s_no', 'agent_name', 'agent_emp_id', 'center_name', 'member_name'].includes(h))
            .map((sku) => ({ id: sku, displayName: sku })),
    ];

    const exportReport = filteredRows.map((row, index) => {
        const baseRow = {
            s_no: index + 1,
            agent_name: row.agent_name,
            agent_emp_id: row.agent_emp_id || '',
        };

        headers.forEach((sku) => {
            if (!['s_no', 'agent_name', 'agent_emp_id', 'center_name', 'member_name'].includes(sku)) {
                baseRow[sku] = row[sku] || 0;
            }
        });

        return baseRow;
    });

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR: AGENT PRODUCT PIVOT</title>
            </Helmet>
            <ContentWrapper>
                <ReportNavBar />
                <div className="card p-2" style={{ marginBottom: "50px" }}>
                    <div className="heading d-flex justify-content-between mb-2">
                        <h5 className="mb-0 text-uppercase mt-2">
                            Agent Wise Product Sale Pivot Table
                        </h5>
                        <div className="mt-1">
                            <Form.Control
                                type="text"
                                placeholder="Search by Agent Name"
                                value={searchTerm}
                                onChange={handleSearch}
                                className="mb-3"
                            />
                        </div>
                        <div className="d-flex">
                            <CsvDownloader
                                filename={`agent_product_pivot_${moment().format("YYYY_MM_DD")}`}
                                extension=".csv"
                                datas={exportReport}
                                columns={column}
                                className="btnorderfilter"
                                style={{ marginTop: "7px" }}
                            >
                                <CiExport className="svgexport" />
                                <span className="btn btn-info btn-sm btnfilter">Export</span>
                            </CsvDownloader>
                            <span onClick={handleReset} className="btnreset">
                                Reset
                            </span>
                            <div className="btnpicker">
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: dateRange.startDate,
                                        endDate: dateRange.endDate,
                                    }}
                                    onApply={handleFilterByDate}
                                >
                                    <button className="btn btn-md btndaterange">Select Date Range</button>
                                </DateRangePicker>
                            </div>
                        </div>
                    </div>

                    <div className="table pagetable table-responsive">
                        <Table
                            className="table-sm table-fixeds"
                            responsive
                            striped
                            bordered
                            hover
                        >
                            <thead>
                                <tr>
                                    {headers.map((h, i) => (
                                        <th key={i}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    [...Array(5)].map((_, rIdx) => (
                                        <tr key={rIdx}>
                                            {headers.map((_, cIdx) => (
                                                <td key={cIdx}>
                                                    <Skeleton />
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredRows.length > 0 ? (
                                    filteredRows.map((row, rIdx) => (
                                        <tr key={rIdx}>
                                            {headers.map((h, cIdx) => (
                                                <td key={cIdx}>{row[h] ?? 0}</td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={headers.length} className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default withAuth(SameProductReport);
